import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './Components/Auth/login.component';
import { OrgInputComponent } from './Components/Auth/org-input.component';
import { OrgSelectorComponent } from './Components/Auth/org-selector.component';
import { DashboardComponent } from './Dashboard/dashboard.component';
import { AuthGuard } from './Services/auth.guard';
import { OrgInitGuard } from './Services/org-init.guard';
import { RestrictedAccessComponent } from './app.restricted.access';
import { AppRedirectorComponent } from './appRedirector';
import { RegisterComponent } from './Components/Auth/register.component'; // Assuming you have this component
import { ForgotPasswordComponent } from './Components/Auth/forgot-password.component'; // Assuming you have this component
import { ResetPasswordComponent } from './Components/FitnessBox/FitBoxAdmin/resetPasswordComponent';

const routes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [OrgInitGuard] },
  { path: 'register', component: RegisterComponent, canActivate: [OrgInitGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent, data: { title: 'Forgot Password' }, canActivate: [OrgInitGuard] },
  { path: 'reset-password', component: ResetPasswordComponent, data: { title: 'Reset Password' }, canActivate: [AuthGuard] },
  { path: 'org-selector', component: OrgSelectorComponent, canActivate: [AuthGuard] },
  { path: 'org-input', component: OrgInputComponent, canActivate: [OrgInitGuard] },
  // Default route - let APP_INITIALIZER handle the redirect
  //{ path: '', component: OrgInputComponent },
  //{ path: '**', redirectTo: '' }
  { path: 'redirector', component: AppRedirectorComponent },
  { path: 'restrictedaccess', component: RestrictedAccessComponent },
  
  // Protected routes with AuthGuard
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'home', component: DashboardComponent },
      // Lazy load feature modules
      {
        path: 'store',
        loadChildren: () => import('./Components/Product/product.module').then(m => m.ProductModule)
      },
      {
        path: 'collection',
        loadChildren: () => import('./Components/CommonCollections/collections.module').then(m => m.CollectionsModule)
      },
      {
        path: 'transaction',
        loadChildren: () => import('./Components/Transaction/transaction.module').then(m => m.TransactionModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./Components/ApplicationSettings/appsettings.module').then(m => m.AppSettingsModule)
      },
      {
        // FitnessBox routes registered at root level (no path prefix)
        path: 'core',
        loadChildren: () => import('./Components/FitnessBox/fitnessbox.module').then(m => m.FitnessCentreModule)
      }
    ]
  },
  
  // Wildcard route
  //{ path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { 
    relativeLinkResolution: 'corrected',
    useHash: false  // Use regular routes without hash
    //initialNavigation: 'disabled'  // Disable initial navigation - let APP_INITIALIZER handle it
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
